import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    padding: {
      sm: '32px 40px 40px 40px',
      xs: '30px 20px',
    },
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    overflow: 'hidden',
    width: '100%',
  },
  buttonsWrapper: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  buttonsRenderer: {
    justifyContent: 'center',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
